/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { SET_READY, REFRESH_LOCALE } from 'actions/app';

import {
  GET_JOB_REQUEST,
  GET_JOB_SUCCESS,
  GET_JOB_FAILURE,
  CREATE_JOB_REQUEST,
  CREATE_JOB_SUCCESS,
  CREATE_JOB_FAILURE,
  UPDATE_JOB_REQUEST,
  UPDATE_JOB_SUCCESS,
  UPDATE_JOB_FAILURE,
} from 'actions/job';

import p from 'polyglot/polyglot';

const initialState = () => ({
  fieldsets: [
    {
      legend: '',
      inputs: [
        {
          type: 'select',
          name: 'job_type',
          label: p.t('jobs.form.job_type.label'),
          placeholder: p.t('jobs.form.job_type.placeholder'),
          options: [],
          constraints: null,
          required: true,
          colWidth: 12,
          tool_tip:
            'Depending on the type of project, talents will be willing to work with you at different rate.',
        },
        {
          type: 'text',
          name: 'title',
          label: p.t('jobs.form.title.label'),
          placeholder: p.t('jobs.form.title.placeholder'),
          constraints: null,
          required: true,
          colWidth: 12,
          tool_tip: '',
        },
        {
          type: 'datepicker',
          name: 'dates',
          label: p.t('jobs.form.dates.label'),
          placeholder: p.t('jobs.form.dates.placeholder'),
          format: 'yyyy-MM-dd',
          multiple: true,
          constraints: null,
          required: true,
          colWidth: 12,
          clearRight: true,
          tool_tip:
            'Select the number of days you need a talent for. You will get a chance to request specific days for specific talent once you request them. And you can always go back and change the dates.',
        },
        {
          type: 'checkbox',
          name: 'has_flexible_dates',
          label: p.t('jobs.form.has_flexible_dates.label'),
          placeholder: p.t('jobs.form.has_flexible_dates.placeholder'),
          constraints: null,
          required: false,
          clearRight: true,
          tool_tip: '',
        },
        {
          type: 'googleplaces',
          name: 'location',
          label: p.t('jobs.form.location.label'),
          placeholder: p.t('jobs.form.location.placeholder'),
          constraints: null,
          required: false,
          colWidth: 12,
          tool_tip: '',
        },
        {
          type: 'select',
          name: 'usage_rights',
          label: p.t('jobs.form.usage_rights.label'),
          placeholder: p.t('jobs.form.usage_rights.placeholder'),
          options: [],
          constraints: null,
          required: true,
          colWidth: 12,
          clearRight: true,
          tool_tip:
            'This is the length of time an image or images will be used: one year, two year, one time, etc.. It is best to specify “from date of first use” when negotiating a contract for an image. Standard use generally defaults to one year use {from shoot date} in a specific medium unless terms are otherwise negotiated.',
        },
        {
          type: 'text',
          name: 'description',
          label: p.t('jobs.form.description.label'),
          placeholder: p.t('jobs.form.description.placeholder'),
          constraints: null,
          required: false,
          colWidth: 12,
          tool_tip: '',
        },
        {
          type: 'file',
          name: 'picture_cloudinary_public_id',
          label: p.t('jobs.form.picture_cloudinary_public_id.label'),
          placeholder: p.t(
            'jobs.form.picture_cloudinary_public_id.placeholder'
          ),
          constraints: null,
          required: false,
        },
      ],
    },
  ],
  validationMessages: {
    required: p.t('general.form.required'),
  },
  submitText: p.t('general.form.submit'),
  sending: false,
  errors: {},
});

/**
 * This is the createProfileForm reducer. It listens for actions and updates the createProfileForm object.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default function(
  state = (state = {
    fieldsets: [
      {
        legend: '',
        inputs: [],
      },
    ],
    validationMessages: {},
    submitText: '',
    sending: false,
    errors: {},
  }),
  { type, payload }
) {
  switch (type) {
    case REFRESH_LOCALE:
    case SET_READY:
      return initialState();

    case GET_JOB_REQUEST:
    case UPDATE_JOB_REQUEST:
    case CREATE_JOB_REQUEST:
      return {
        ...state,
        sending: true,
        errors: {},
      };

    case GET_JOB_SUCCESS:
    case UPDATE_JOB_SUCCESS:
    case CREATE_JOB_SUCCESS:
      return {
        ...state,
        sending: false,
        errors: {},
      };

    case GET_JOB_FAILURE:
    case UPDATE_JOB_FAILURE:
    case CREATE_JOB_FAILURE:
      return {
        ...state,
        sending: false,
        errors: payload.errors || {}, // @TODO: FORMAT ERRORS!
      };

    default:
      return state;
  }
}
